module.exports = __webpack_public_path__ + "img/login.a20dead2.png";